//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_ANTICOCCIDAL_LIST = 'SET_ANTICOCCIDAL_LIST';
export const CLEAR_ANTICOCCIDAL_LIST = 'CLEAR_ANTICOCCIDAL_LIST';
export const ANTICOCCIDAL_LIST_PENDING = 'ANTICOCCIDAL_LIST_PENDING';
export const ANTICOCCIDAL_LIST_ERROR = 'ANTICOCCIDAL_LIST_ERROR';
export const ANTICOCCIDAL_LIST_ERROR_CLEAR = 'ANTICOCCIDAL_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const ANTICOCCIDAL_FILTER_DIALOG_OPEN = 'ANTICOCCIDAL_FILTER_DIALOG_OPEN';
export const ANTICOCCIDAL_FILTER_DIALOG_CLOSE = 'ANTICOCCIDAL_FILTER_DIALOG_CLOSE';
export const SET_ANTICOCCIDAL_FILTER_DATA = 'SET_ANTICOCCIDAL_FILTER_DATA';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const ANTICOCCIDAL_CREATE_DIALOG_OPEN = 'ANTICOCCIDAL_CREATE_DIALOG_OPEN';
export const ANTICOCCIDAL_CREATE_DIALOG_CLOSE = 'ANTICOCCIDAL_CREATE_DIALOG_CLOSE';
export const ANTICOCCIDAL_CREATE_PENDING = 'ANTICOCCIDAL_CREATE_PENDING';
export const ANTICOCCIDAL_CREATE_ERROR = 'ANTICOCCIDAL_CREATE_ERROR';
export const ANTICOCCIDAL_CREATE_ERROR_CLEAR = 'ANTICOCCIDAL_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const ANTICOCCIDAL_EDIT_DIALOG_OPEN = 'ANTICOCCIDAL_EDIT_DIALOG_OPEN';
export const ANTICOCCIDAL_EDIT_DIALOG_CLOSE = 'ANTICOCCIDAL_EDIT_DIALOG_CLOSE';
export const ANTICOCCIDAL_EDIT_PENDING = 'ANTICOCCIDAL_EDIT_PENDING';
export const ANTICOCCIDAL_EDIT_ERROR = 'ANTICOCCIDAL_EDIT_ERROR';
export const ANTICOCCIDAL_EDIT_ERROR_CLEAR = 'ANTICOCCIDAL_EDIT_ERROR_CLEAR';